import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";

import RoutesApp from "./config/Routes";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";  
import { Provider } from "react-redux" 
import { applyMiddleware, Store } from "redux"
import { legacy_createStore as createStore } from 'redux';
import { thunk } from 'redux-thunk';
import reducer from "./store/reducer" 
import { DispatchType, MenuAction, MenuState } from "./store/types/types";
import { composeWithDevTools } from '@redux-devtools/extension';
 
const store: Store<MenuState, MenuAction> & {
  dispatch: DispatchType
} = createStore(reducer, composeWithDevTools(applyMiddleware(thunk)))
// import { getStore } from './store/storeHandler';


const App: React.FC = () => (
  <Provider store={store}> 
    <BrowserRouter>   
      <ToastProvider> 
        <AuthProvider> 
            <RoutesApp /> 
        </AuthProvider> 
      </ToastProvider>   
    </BrowserRouter> 
   </Provider>
  
);

export default App;
